import React, { useEffect, useState } from 'react';
import { LayerGroup, LayersControl, TileLayer } from 'react-leaflet';
import { useSelector } from 'react-redux';
import { currentZoomLevelState, isShowRegionLayersState } from '../../../../../app/redux/retrievers/retrievers';
import RegionPolygons from '../../MapShapeLayers/PolygonLayer/RegionPolygons/RegionPolygons';
import { mapTileUrlList } from '../mapTileUrlList';
import RegionPoints from '../../PointLayer/RegionPoints/RegionPoints';
import { regionOverlayData } from './data/regionOverlayData';
import { MapRegionOverlay } from '../../../../../core/types/types';
import { RegionEnum } from '../../../../../core/enums/region.enums';
import { GetTemperatureDataApi } from '../../../../../core/data/api/earth-engine/GetTemperatureDataApi';
import axios from 'axios';

const REGION_TILES_SERVER = process.env.REACT_APP_REGIONS_SERVER;
const EARTH_ENGINE_TILES_URL = process.env.REACT_APP_EARTH_ENGINE_TILES_URL;

const OverlaysController = () => {
    const { Overlay } = LayersControl;
    const currentZoom = useSelector(currentZoomLevelState);
    const isShowRegionLayers = useSelector(isShowRegionLayersState);
    // const [overlayOptions, setOverlayOptions] = useState<any>();
    // const [pickedLayer, setPickedLayer] = useState<number>(0);
    // const [removedLayer, setRemovedLayer] = useState<number>(0);
    // const [pickedPointLayer, setPickedPointLayer] = useState<number>(0);
    const [temperatureDataTilesUrl, setTemparatureDataTilesUrl] = useState<string>('');

    // const handleLayerGroupEvents = (value: number, region: RegionEnum) => {
    //     return {
    //         add: () => {
    //             region !== RegionEnum.CityCenter ? setPickedLayer(value) : setPickedPointLayer(value);
    //         },
    //         // remove: () => {
    //         //     setRemovedLayer(region.valueOf());
    //         // },
    //     };
    // };
    // useEffect(() => {
    //     async function fetchData() {
    //         try {
    //             setTemparatureDataTilesUrl(await GetTemperatureDataApi());
    //         } catch (error) {
    //             console.error('Error fetching temperature data:', error);
    //         }
    //     }
    //     fetchData();
    // }, []);

    return (
        <div>
            {/*region data overlays */}
            <LayersControl position="bottomright">
                <Overlay name="پوشش جاده ها">
                    <TileLayer url={mapTileUrlList.googleMapsRoads} />
                </Overlay>

                {isShowRegionLayers && (
                    <>
                        {currentZoom >= 13 && currentZoom <= 15 && (
                            <Overlay name="پوشش دهستان ها" checked={currentZoom >= 13 && currentZoom <= 15}>
                                <TileLayer url={`${REGION_TILES_SERVER}/dehestan/{z}/{x}/{y}.png`} />
                            </Overlay>
                        )}
                        {currentZoom >= 11 && currentZoom <= 12 && (
                            <Overlay name="پوشش بخش ها" checked={currentZoom >= 11 && currentZoom <= 12}>
                                <TileLayer url={`${REGION_TILES_SERVER}/bakhsh/{z}/{x}/{y}.png`} />
                            </Overlay>
                        )}
                        {currentZoom >= 9 && currentZoom <= 10 && (
                            <Overlay name="پوشش شهرستان ها" checked={currentZoom >= 9 && currentZoom <= 10}>
                                <TileLayer url={`${REGION_TILES_SERVER}/shahrestan/{z}/{x}/{y}.png`} />
                            </Overlay>
                        )}
                        {currentZoom >= 5 && currentZoom <= 8 && (
                            <Overlay name="پوشش استان ها" checked={currentZoom >= 5 && currentZoom <= 8}>
                                <TileLayer url={`${REGION_TILES_SERVER}/ostan/{z}/{x}/{y}.png`} />
                            </Overlay>
                        )}
                    </>
                )}

                {/* )} */}
            </LayersControl>

            {/*Earth Engine data overlays */}
            {/* <LayersControl position="bottomleft">
                <Overlay name="temp">
                    <TileLayer
                        url={`${EARTH_ENGINE_TILES_URL}/93bdb3ae12a6b1d3e37a5ea387fe030d-a7ff666e20106505f0e1c274efc70eb4/tiles/{z}/{x}/{y}`}
                        opacity={0.8}
                    />
                </Overlay>
                <Overlay name="methane">
                    <TileLayer
                        url={`${EARTH_ENGINE_TILES_URL}/ca754b81afde299b4f575145353f2566-d53245a62107382dbcf4e2a0ec4529b4/tiles/{z}/{x}/{y}`}
                        opacity={0.8}
                    />
                </Overlay>
                <Overlay name="soil">
                    <TileLayer
                        url={`${EARTH_ENGINE_TILES_URL}/c963788594386c87d8f30dae88ac408a-efc3c29267ad8a8b3e412b55e125bfc1/tiles/{z}/{x}/{y}`}
                        opacity={0.8}
                    />
                </Overlay>
                <Overlay name="temp2">
                    <TileLayer url={temperatureDataTilesUrl} opacity={0.8} />
                </Overlay>
            </LayersControl> */}
        </div>
    );
};

export default OverlaysController;
{
    /* {regionOverlayData &&
                regionOverlayData.map((overlay: MapRegionOverlay) =>
                    overlay.value !== RegionEnum.None ? (
                        <Overlay
                            key={overlay.value}
                            name={overlay.label}
                            // checked={pickedLayer === overlay.region.valueOf()}
                        >
                            <LayerGroup eventHandlers={handleLayerGroupEvents(overlay.value, overlay.region)}>
                                {overlay.shapes === 'polygon' ? (
                                    <RegionPolygons
                                        regionType={overlay.region}
                                        regionColor={overlay.color}
                                        pickedLayer={pickedLayer}
                                        // removedLayer={removedLayer}
                                    />
                                ) : (
                                    <RegionPoints
                                        regionType={overlay.region}
                                        regionColor={overlay.color}
                                        pickedLayer={pickedPointLayer}
                                    />
                                )}
                            </LayerGroup>
                        </Overlay>
                    ) : (
                        // <Overlay name={overlay.label}>
                        //     {/* <TileLayer url={mapTileUrlList.googleMapsRoads} /> 
                        //     <TileLayer url={'https://region.mymaproom.ir/shahrestan/{z}/{x}/{y}.png'} opacity={1}/>
                        // </Overlay>
                        <></>
                    ),
                )} */
}
{
    // useEffect(() => {
    //     setOverlayOptions(
    //         regionOverlayData &&
    //             regionOverlayData.map((overlay: MapRegionOverlay) =>
    //                 overlay.value !== RegionEnum.None ? (
    //                     <Overlay
    //                         key={overlay.value}
    //                         name={overlay.label}
    //                         // checked={pickedLayer === overlay.region.valueOf()}
    //                     >
    //                         <LayerGroup eventHandlers={handleLayerGroupEvents(overlay.value, overlay.region)}>
    //                             {overlay.shapes === 'polygon' ? (
    //                                 <RegionPolygons
    //                                     regionType={overlay.region}
    //                                     regionColor={overlay.color}
    //                                     pickedLayer={pickedLayer}
    //                                     removedLayer={removedLayer}
    //                                 />
    //                             ) : (
    //                                 <RegionPoints
    //                                     regionType={overlay.region}
    //                                     regionColor={overlay.color}
    //                                     pickedLayer={pickedPointLayer}
    //                                 />
    //                             )}
    //                         </LayerGroup>
    //                     </Overlay>
    //                 ) : (
    //                     <Overlay name={overlay.label}>
    //                         <TileLayer url={mapTileUrlList.googleMapsRoads} />
    //                     </Overlay>
    //                 ),
    //             ),
    //     );
    // }, [pickedLayer, pickedPointLayer]);
    {
        /* {(mapTileUrl === mapTileUrlList.googleMapsSatellite ||
                mapTileUrl === mapTileUrlList.bingMapSatellite ||
                mapTileUrl === mapTileUrlList.arcGIS) && (
                */
    }
    {
        /* <Overlay name="پوشش جاده ها">
                    <TileLayer url={mapTileUrlList.googleMapsRoads} />
                </Overlay> */
    }
    // remove: () => {
    //     // region !== RegionEnum.CityCenter ? setPickedLayer(0) : setPickedPointLayer(value);
    // },
    /* {regionOverlayData &&
                    regionOverlayData.map((overlay: MapRegionOverlay) => (
                        <Overlay key={overlay.value} name={overlay.label} checked={pickedLayer === overlay.region.valueOf()}>
                            <LayerGroup eventHandlers={handleLayerGroupEvents(overlay.value, overlay.region)}>
                                {overlay.shapes === 'polygon' ? (
                                    <RegionPolygons regionType={overlay.region} pickedLayer={pickedLayer} />
                                ) : (
                                    <RegionPoints regionType={overlay.region} pickedLayer={pickedPointLayer} />
                                )}
                            </LayerGroup>
                        </Overlay>
                    ))} */
}
